import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import t from 'format-message';
import PropTypes from 'prop-types';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Heading } from '@instructure/ui-heading';
import { Flex } from '@instructure/ui-flex';
import { Modal } from '@instructure/ui-modal';
import { View } from '@instructure/ui-view';
import { Tray } from '@instructure/ui-tray';
import { Spinner } from '@instructure/ui-spinner';
import { withStyle, jsx } from '@instructure/emotion';
import OutcomeList from "./OutcomeList/index.js";
import SearchInput from "../SearchInput/index.js";
import SearchResults from "../SearchResults/index.js";
import generateComponentTheme from "../theme.js";
import generateStyle from "./styles.js";
import { outcomeShape, stylesShape } from "../../store/shapes.js";
var ModalFooter = Modal.Footer;
var OutcomeTray = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(OutcomeTray, _React$Component);
  var _super = _createSuper(OutcomeTray);
  function OutcomeTray() {
    _classCallCheck(this, OutcomeTray);
    return _super.apply(this, arguments);
  }
  _createClass(OutcomeTray, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        getOutcomesList = _this$props.getOutcomesList,
        isOpen = _this$props.isOpen,
        updateSearchText = _this$props.updateSearchText,
        setInitialSelectedOutcomes = _this$props.setInitialSelectedOutcomes;
      if (!prevProps.isOpen && isOpen) {
        getOutcomesList({
          page: 1
        });
        updateSearchText('');
        setInitialSelectedOutcomes();
      }
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _this$props2 = this.props,
        outcomes = _this$props2.outcomes,
        isOutcomeSelected = _this$props2.isOutcomeSelected,
        selectOutcomeIds = _this$props2.selectOutcomeIds,
        deselectOutcomeIds = _this$props2.deselectOutcomeIds,
        isFetching = _this$props2.isFetching,
        listPage = _this$props2.listPage,
        listTotal = _this$props2.listTotal,
        getOutcomesList = _this$props2.getOutcomesList,
        features = _this$props2.features;
      return jsx(View, {
        display: "block",
        padding: "small none none none"
      }, jsx(OutcomeList, {
        outcomes: outcomes,
        isOutcomeSelected: isOutcomeSelected,
        selectOutcomeIds: selectOutcomeIds,
        deselectOutcomeIds: deselectOutcomeIds,
        isLoading: isFetching,
        listPage: listPage,
        listTotal: listTotal,
        getOutcomesList: getOutcomesList,
        features: features
      }));
    }
  }, {
    key: "renderSearchMode",
    value: function renderSearchMode() {
      var _this$props3 = this.props,
        screenreaderNotification = _this$props3.screenreaderNotification,
        setSearchLoading = _this$props3.setSearchLoading,
        setSearchEntries = _this$props3.setSearchEntries,
        searchText = _this$props3.searchText,
        updateSearchPage = _this$props3.updateSearchPage,
        isSearchLoading = _this$props3.isSearchLoading,
        isOutcomeSelected = _this$props3.isOutcomeSelected,
        searchEntries = _this$props3.searchEntries,
        searchPage = _this$props3.searchPage,
        searchTotal = _this$props3.searchTotal,
        selectOutcomeIds = _this$props3.selectOutcomeIds,
        deselectOutcomeIds = _this$props3.deselectOutcomeIds;
      return jsx(SearchResults, {
        screenreaderNotification: screenreaderNotification,
        setSearchLoading: setSearchLoading,
        setSearchEntries: setSearchEntries,
        searchText: searchText,
        updateSearchPage: updateSearchPage,
        isSearchLoading: isSearchLoading,
        isOutcomeSelected: isOutcomeSelected,
        searchEntries: searchEntries,
        searchPage: searchPage,
        searchTotal: searchTotal,
        selectOutcomeIds: selectOutcomeIds,
        deselectOutcomeIds: deselectOutcomeIds
      });
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this$props4 = this.props,
        searchText = _this$props4.searchText,
        isFetching = _this$props4.isFetching;
      if (isFetching) {
        return jsx(Flex, {
          justifyItems: "center"
        }, jsx(Flex.Item, {
          padding: "small"
        }, jsx(Spinner, {
          renderTitle: t('Loading')
        })));
      }
      return searchText ? this.renderSearchMode() : this.renderList();
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this = this;
      var _this$props5 = this.props,
        saveOutcomePickerAlignments = _this$props5.saveOutcomePickerAlignments,
        onUpdate = _this$props5.onUpdate,
        closeOutcomePicker = _this$props5.closeOutcomePicker,
        shouldModifyArtifact = _this$props5.shouldModifyArtifact;
      return saveOutcomePickerAlignments(onUpdate, shouldModifyArtifact).then(function () {
        _this.props.showAlert(t('Outcome alignments have been successfully updated.'));
        closeOutcomePicker();
      });
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this2 = this;
      var closeOutcomePicker = this.props.closeOutcomePicker;
      return jsx("div", {
        css: this.props.styles.footerContainer
      }, jsx(ModalFooter, null, jsx(Button, {
        margin: "xxx-small",
        onClick: closeOutcomePicker
      }, t('Cancel')), jsx(Button, {
        margin: "xxx-small",
        color: "primary",
        onClick: function onClick() {
          return _this2.handleSubmit();
        }
      }, t('Confirm Alignments'))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        liveRegion = _this$props6.liveRegion,
        mountNode = _this$props6.mountNode,
        searchText = _this$props6.searchText,
        placement = _this$props6.placement,
        size = _this$props6.size,
        updateSearchText = _this$props6.updateSearchText,
        closeOutcomePicker = _this$props6.closeOutcomePicker,
        isOpen = _this$props6.isOpen,
        resetOutcomePicker = _this$props6.resetOutcomePicker;
      var trayProps = {
        placement: placement,
        size: size
      };
      return jsx(Tray, Object.assign({
        "data-automation": "outcomeTrayPicker__view",
        liveRegion: liveRegion,
        mountNode: mountNode,
        open: isOpen,
        onExiting: resetOutcomePicker,
        label: t('Align Outcomes')
      }, trayProps), jsx("div", {
        css: this.props.styles.outcomeTray
      }, jsx("div", {
        css: this.props.styles.trayContainer
      }, jsx(Flex, {
        margin: "none none small none"
      }, jsx(Flex.Item, {
        shouldGrow: true,
        shouldShrink: true
      }, jsx(Heading, {
        level: "h3",
        margin: "0 0 x-small"
      }, t('Align Outcomes'))), jsx(Flex.Item, null, jsx(CloseButton, {
        onClick: closeOutcomePicker,
        screenReaderLabel: t('Cancel')
      }))), jsx(SearchInput, {
        onChange: function onChange(_, value) {
          return updateSearchText(value);
        },
        onClear: function onClear() {
          return updateSearchText('');
        },
        searchText: searchText
      }), this.renderBody()), this.renderActions()));
    }
  }]);
  OutcomeTray.displayName = "OutcomeTray";
  return OutcomeTray;
}(React.Component), _class2.propTypes = {
  searchText: PropTypes.string.isRequired,
  updateSearchText: PropTypes.func.isRequired,
  setSearchLoading: PropTypes.func.isRequired,
  setSearchEntries: PropTypes.func.isRequired,
  isSearchLoading: PropTypes.bool.isRequired,
  searchEntries: PropTypes.array.isRequired,
  setFocusedOutcome: PropTypes.func.isRequired,
  isOutcomeSelected: PropTypes.func.isRequired,
  selectOutcomeIds: PropTypes.func.isRequired,
  deselectOutcomeIds: PropTypes.func.isRequired,
  saveOutcomePickerAlignments: PropTypes.func.isRequired,
  screenreaderNotification: PropTypes.func,
  liveRegion: Tray.propTypes.liveRegion,
  mountNode: Tray.propTypes.mountNode,
  size: PropTypes.string,
  placement: PropTypes.string,
  searchTotal: PropTypes.number,
  searchPage: PropTypes.number.isRequired,
  outcomes: PropTypes.array.isRequired,
  getOutcomesList: PropTypes.func.isRequired,
  updateSearchPage: PropTypes.func.isRequired,
  listPage: PropTypes.number.isRequired,
  listTotal: PropTypes.number,
  isFetching: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeOutcomePicker: PropTypes.func.isRequired,
  resetOutcomePicker: PropTypes.func.isRequired,
  setInitialSelectedOutcomes: PropTypes.func.isRequired,
  onUpdate: PropTypes.func,
  focusedOutcome: outcomeShape,
  artifactTypeName: PropTypes.string,
  displayMasteryDescription: PropTypes.bool,
  displayMasteryPercentText: PropTypes.bool,
  shouldModifyArtifact: PropTypes.bool,
  scope: PropTypes.string.isRequired,
  showAlert: PropTypes.func,
  features: PropTypes.array,
  styles: stylesShape
}, _class2.defaultProps = {
  screenreaderNotification: null,
  liveRegion: null,
  mountNode: null,
  size: 'regular',
  placement: 'end',
  onUpdate: null,
  focusedOutcome: null,
  artifactTypeName: null,
  displayMasteryDescription: false,
  displayMasteryPercentText: false,
  shouldModifyArtifact: false,
  searchTotal: null,
  listTotal: null,
  showAlert: function showAlert() {},
  features: []
}, _class2)) || _class);
export { OutcomeTray as default };